// extracted by mini-css-extract-plugin
export default {"container":"logo-module--container--28Oba","logo":"logo-module--logo--2KAHm","text":"logo-module--text--3jcG9","stacked":"logo-module--stacked--2Bc6I"};